import { Pipe, PipeTransform } from "@angular/core";

/**
 * Pipe para exibir um array de números agrupados em ranges.
 *
 * Exemplo: [1,2,3,5,6,7,10] -> "1-3, 5-7, 10".
 *
 * @author Rafael Senna
 */
@Pipe({ name: "numericRangeFormatter" })
export class NumericRangeFormatterPipe implements PipeTransform {

    transform(numbersArray: number[]): string {
        if (!numbersArray) {
            return "";
        }

        const ranges = this.groupByRange(numbersArray);
        const rangesStrings = this.formatRanges(ranges);

        return rangesStrings.join(", ");
    }


    private groupByRange(numbersArray: number[]) {
        numbersArray = Array.from(new Set(numbersArray.map(Number))).sort((a, b) => a - b);

        const ranges = [];
        let currentRange: any = {};

        numbersArray.forEach((number, index) => {
            if (Object.keys(currentRange).length === 0) {
                currentRange.first = number;
            }

            if (number + 1 !== numbersArray[index + 1]) {
                currentRange.last = number;
                ranges.push(currentRange);

                currentRange = {};
            }
        });

        return ranges;
    }

    private formatRanges(ranges: { first: number, last: number }[]): string[] {
        return ranges.map(range =>
            range.first === range.last ?
                 `${range.first}` :
                 `${range.first}-${range.last}`
            );
    }
}
